import styled, { css } from 'styled-components';

interface ImgProps {
  $width?: number;
  $height?: number;
  $isAvailable: boolean;
}
export const ProductImage = styled.img<ImgProps>`
  border-radius: 4px;
  object-fit: cover;
  ${({ $width = 56, $height = 72, $isAvailable }) => css`
    width: ${$width}px;
    height: ${$height}px;
    min-width: ${$width}px;
    min-height: ${$height}px;
    filter: ${$isAvailable ? 'none' : 'brightness(0.4)'};
  `}
`;

export const OutStockTag = styled.span`
  position: absolute;
  top: 24px;
  left: 4px;

  font-size: 12px;
  line-height: 24px;
  font-weight: 500;

  background-color: ${({ theme }) => theme.palette.common.DISABLED};
  text-align: center;

  border-radius: 4px;
  padding: 0 4px;

  color: ${({ theme }) => theme.palette.common.TEXTS};
`;
